import React from 'react';
import { Header } from '../components/layout/Header';
import { Sidebar } from '../components/layout/Sidebar';
import { PortfolioOverview } from '../components/home/PortfolioOverview';
import { StatsCards } from '../components/home/StatsCards';
import { MarketSnapshot } from '../components/home/MarketSnapshot';
// import { HoldingsTable } from '../components/home/HoldingsTable'
import { ActivityFeed } from '../components/home/ActivityFeed';
export function HomePage() {
  return <div className="flex h-screen bg-background-primary text-text-primary overflow-hidden font-sans" data-id="element-1861">
      <Sidebar data-id="element-1862" />

      <div className="flex-1 flex flex-col min-w-0" data-id="element-1863">
        <Header data-id="element-1864" />

        <main className="flex-1 overflow-y-auto p-4 md:p-6 space-y-4 md:space-y-6" data-id="element-1865">
          {/* Hero Section */}
          <PortfolioOverview data-id="element-1866" />

          {/* Stats Row */}
          <StatsCards data-id="element-1867" />

          {/* Main Content Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6 min-w-0" data-id="element-1868">
            {/* Left Column - Market Snapshot */}
            <MarketSnapshot data-id="element-1869" />

            {/* Right Column - Activity Feed */}
            <ActivityFeed data-id="element-1870" />
          </div>
        </main>
      </div>
    </div>;
}